import type { ReactNode } from 'react';
import './escala.css';

/**
 * Escala subjetiva 1-5 con los extremos SIEMPRE etiquetados
 * (docs/PRODUCT_SPEC.md §6.1). Botones de 48 px: el check-in debe completarse
 * en 10-15 segundos con una mano.
 */
export function EscalaInput({
  etiqueta,
  valor,
  onChange,
  extremoBajo,
  extremoAlto,
}: {
  etiqueta: string;
  valor: number;
  onChange: (valor: number) => void;
  extremoBajo: string;
  extremoAlto: string;
}): ReactNode {
  const grupoId = `escala-${etiqueta.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <fieldset className="escala" aria-labelledby={`${grupoId}-titulo`}>
      <legend className="escala__titulo" id={`${grupoId}-titulo`}>
        {etiqueta}
      </legend>
      <div className="escala__botones" role="radiogroup" aria-labelledby={`${grupoId}-titulo`}>
        {[1, 2, 3, 4, 5].map((opcion) => (
          <button
            key={opcion}
            type="button"
            role="radio"
            aria-checked={valor === opcion}
            aria-label={`${etiqueta}: ${opcion} de 5`}
            className={`escala__boton${valor === opcion ? ' escala__boton--activo' : ''}`}
            onClick={() => onChange(opcion)}
          >
            {opcion}
          </button>
        ))}
      </div>
      <div className="escala__extremos">
        <span>{extremoBajo}</span>
        <span>{extremoAlto}</span>
      </div>
    </fieldset>
  );
}
